import marchSkin from '../../public/skins/march2024/skin.json';
import { campaingStore } from "Store/data";
import { get } from "svelte/store";
import { appSettings } from './settings';

function getAppHost() {
  try {
    let url = appSettings.getUrl()
    console.log('Current Host:', url);
    return url
  } catch {
    return `https://static-loyalty-system-r2.bgaming-network.com/BGJPT-738_skin_management`
  }
}

export function getSkin() {
  try {
    return appSettings.getSkin();
  } catch {
    console.log("cant access skin on host, set default skin");
    return marchSkin;
  }
}

export function getSkinJson() {
  const host = getAppHost();
  const currentCampaign = get(campaingStore.campaign);
  const skinUrl = `/skins/${currentCampaign.skin}/`;
  fetch(`${host}${skinUrl}skin.json`)
    .then((res) => {
      if (!res.ok) {
        throw new Error
          (`HTTP error! Status: ${res.status}`);
      }
      return res.json();
    })
    .then((response) => {
      if (validateSkin(response)) {
        appSettings.setSkin(response);
      } else {
        appSettings.setSkin(marchSkin);
      }
    })
    .catch((error) => {
      console.error("Unable to fetch Skin:", error);
      appSettings.setSkin(marchSkin);
    });
}

const validateSkin = (skin) => {
  return skin &&
    skin.id &&
    skin.skinHeaderImage ? skin : null;
}

export function getSkinImg(key) {
  const currentCampaign = get(campaingStore.campaign);
  //const host = `https://static-loyalty-system-r2.bgaming-network.com/BGJPT-738_skin_management/`;
  const host = getAppHost()
  const skinUrl = `/skins/${currentCampaign.skin}/`;
  //const skinUrl = `skins/march2024_mBit/`;

  return `${host}${skinUrl}${key}`;
}
